import React, { Component } from "react";
import PropTypes from "prop-types";
import { CDropDown } from "@appcues/component-library";
import { getPermissionValueForUser } from "helpers/account-management";
import {
  ACCOUNT_PERMISSION_DROPDOWN,
  LIMITED_ACCOUNT_PERMISSION_DROPDOWN
} from "constants/accountManagement/permissions";

class UserPermissionsSelectInput extends Component {
  static propTypes = {
    onSelectPermission: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    accountUsers: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    hasEditorPermissionsRole: PropTypes.bool.isRequired
  };

  updatePermission = value => {
    const { onSelectPermission, user } = this.props;
    onSelectPermission(value, user);
  };

  render() {
    const {
      accountUsers,
      user,
      disabled,
      hasEditorPermissionsRole
    } = this.props;

    return (
      <CDropDown
        disabled={disabled}
        value={getPermissionValueForUser({
          user,
          accountUsers
        })}
        options={
          hasEditorPermissionsRole
            ? ACCOUNT_PERMISSION_DROPDOWN
            : LIMITED_ACCOUNT_PERMISSION_DROPDOWN
        }
        minMenuWidth={420}
        onChange={this.updatePermission}
      />
    );
  }
}

export default UserPermissionsSelectInput;
